// Set API_ENV [dev/uat/staging/produciton]
let API_ENV = 'dev';

/**
 * Find the env base on the domain
 */
if (window && window.location) {
  switch (window.location.host) {
    case 'editor-dev.madlogic.nl':
      API_ENV = 'dev';
      break;
    case 'editor-uat.madlogic.nl':
    case 'editor-uat.sqoony.com':
      API_ENV = 'uat';
      break;
    case 'editor-staging.madlogic.nl':
      API_ENV = 'staging';
      break;
    case 'editor.madlogic.nl':
    case 'editor.sqoony.com':
    case '159.69.177.37':
    case '137.117.139.225':
      API_ENV = 'production';
      break;
    case 'p4f-editor.madlogic.nl':
      API_ENV = 'production_p4f';
      break;
    default:
      API_ENV = 'dev';
  }
}

/**
 * The API url for each env
 */
const apiEnv = {
  dev: {
    API_URL: 'https://portal-dev.madlogic.nl/rest/api/v1',
    PLAYER_API_URL: 'https://portal-dev.madlogic.nl/rest/public/v3'
  },
  uat: {
    API_URL: 'https://portal-uat.madlogic.nl:21000/rest/api/v1',
    PLAYER_API_URL: 'https://portal-uat.madlogic.nl:21000/rest/public/v3'
  },
  staging: {
    API_URL: 'https://portal-staging.madlogic.nl:22000/rest/api/v1',
    PLAYER_API_URL: 'https://portal-staging.madlogic.nl:22000/rest/public/v3'
  },
  production: {
    API_URL: 'https://api.sqoony.com/rest/api/v1',
    PLAYER_API_URL: 'https://api.sqoony.com/rest/public/v3'
  },
  production_p4f: {
    API_URL: 'https://p4f-api.madlogic.nl/rest/api/v1',
    PLAYER_API_URL: 'https://p4f-api.madlogic.nl/rest/public/v3'
  },
  migration: {
    API_URL: 'https://migration.sqoony.com/rest/api/v1',
    PLAYER_API_URL: 'https://uat.sqoony.com/rest/public/v3'
  }
}[API_ENV];

/**
 * Local server for develop
 */
const serverEnv = {
  development: {
    SERVER_URL: 'https://editor-dev.madlogic.nl/api/v1'
  },
  production: {
    SERVER_URL: '/api/v1'
  }
}[process.env.NODE_ENV || 'development'];

export const { API_URL, PLAYER_API_URL } = apiEnv;
export const { SERVER_URL } = serverEnv;



// WEBPACK FOOTER //
// ./src/configs/env.config.js